import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import InitiativeValidations from 'scaleflow/validators/initiative';
export default class InitiativesTableTitleComponent extends Component {
  @tracked isEditMode = false;
  initiativeValidations = InitiativeValidations;

  @action
  toggleEditMode() {
    this.isEditMode = !this.isEditMode;
  }

  @action
  async saveTitle(changeset, e) {
    e?.preventDefault?.();
    await changeset.validate();
    if (!changeset.get('isValid')) return;
    changeset.save().catch((err) => {
      console.debug(err);
      changeset.rollback();
    });
    this.toggleEditMode();
  }
}
